// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubjectChoice/Start.less
// module id = 1636
// module chunks = 0